const eventLoadMore = document.getElementById('js-events-load-more');
const eventLoadMoreText = document.getElementById('js-events-load-more-text');

const loadMore = () => {
  if (!eventLoadMore) {
    return;
  }

  return;
  // eventLoadMore.addEventListener('click', (event) => handleEventLoadMoreClick(event));
};

const handleEventLoadMoreClick = (event) => {
  const data = {
    'action': 'eventsLoadMore',
    'query': events_loadmore_params.posts,
    'page': events_loadmore_params.current_page
  };

  eventLoadMore.classList.add('is-active');

  console.log('^^', events_loadmore_params);

  $.ajax({
    url: events_loadmore_params.ajaxurl,
    data,
    type: 'POST',
    beforeSend: (xhr) => {
      eventLoadMoreText.innerHTML = 'Loading...';
    },
    success: (data) => {
      console.log('^^', data);

      // if (data) {
      //   // $('#js-event-isotope-cont').append(data);
      //   console.log('^^', data);
      //
      //   eventLoadMoreText.innerHTML = 'More events';
      //   events_loadmore_params.current_page++;
      //
      //   if (events_loadmore_params.current_page === events_loadmore_params.max_page) {
      //     eventLoadMore.classList.remove('is-active');
      //     eventLoadMoreText.innerHTML = 'No more events of this type';
      //   }
      //
      // } else {
      //   eventLoadMore.classList.remove('is-active');
      //   eventLoadMoreText.innerHTML = 'No more events of this type';
      // }
    },
    errors: function (error) {
      console.error(error);
    }
  });
};

export default loadMore;
